import { GetServerSideProps } from 'next'

import { UserService } from 'services/user.service'

import AggregatedUsersLandingPage, { Props } from 'components/misc/AggregatedUsersLandingPage'

import { LOG_ERROR_AND_REDIRECT } from 'utils/ErrorString'

const CommandZonePage = AggregatedUsersLandingPage

export default CommandZonePage

export const getServerSideProps: GetServerSideProps<Props> = async context => {
  try {
    const users = await Promise.all([
      new UserService(context).detailsByUsername('GameKnights'),
      new UserService(context).detailsByUsername('wachelreeks'),
      new UserService(context).detailsByUsername('RachelWeeks_CZ'),
    ])

    return {
      props: {
        users,
        banner: 'https://cards.scryfall.io/art_crop/front/6/d/6d5b06e4-bbc8-405b-bc53-1380dba3696e.jpg?1684198340', // temporary
        title: 'The Command Zone - Archidekt',
        description: '',
        avatar: '',
      },
    }
  } catch (error) {
    return LOG_ERROR_AND_REDIRECT(error, context)
  }
}
